import * as echarts from 'echarts';
import generateRandomStringFromCharacterSet from 'src/utils/encryption/generateRandomStringFromCharacterSet';
import Vue from 'vue';
import performActionAfterDelayIfCheckPasses from 'src/utils/performActionAfterDelayIfCheckPasses';
import debounce from 'quasar/src/utils/debounce.js';;
import placeholderOption from './utils/placeholderOption';
export default Vue.extend({
    name: 'BaseEChart',
    props: {
        option: { type: Object, default: placeholderOption },
        isLoading: { type: Boolean, default: false }
    },
    data() {
        return {
            idString: 'e_chart_placeholder_' + generateRandomStringFromCharacterSet(5),
            myChart: {},
            showLoadingIndicator: false
        };
    },
    computed: {
        computedOption() {
            return this.option;
        }
    },
    watch: {
        computedOption: {
            immediate: true,
            deep: true,
            handler(newVal) {
                if (this.myChart && newVal)
                    this.setOption();
            }
        },
        isLoading: {
            handler(newVal) {
                if (!newVal) {
                    this.showLoadingIndicator = false;
                }
                else {
                    performActionAfterDelayIfCheckPasses(100, () => !this.isLoading, () => { this.showLoadingIndicator = true; });
                }
            },
            immediate: true
        }
    },
    mounted() {
        const chartDom = document.getElementById(this.idString);
        if (chartDom) {
            this.myChart = echarts.init(chartDom);
            this.setOption();
            const resizeObserver = new ResizeObserver(this.resize);
            resizeObserver.observe(chartDom);
            const appContainer = document.querySelector('.q-page-container.app-container');
            if (appContainer) {
                resizeObserver.observe(appContainer);
            }
        }
    },
    created() {
        this.setOption = debounce(this.setOption, 500);
    },
    methods: {
        resize() { this.myChart.resize(); },
        setOption() {
            if (!this.myChart.setOption) {
                console.log('this.myChart.setOption is not defined');
                return;
            }
            this.myChart.setOption(this.computedOption, true /* this tells echarts not to merge with old data but override it */);
        }
    }
});
